import { useEffect } from 'react';

interface SchemaOrgProps {
  type: 'WebPage' | 'SportsEvent' | 'FAQPage' | 'Organization';
  data: Record<string, any>;
}

export const SchemaOrg: React.FC<SchemaOrgProps> = ({ type, data }) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = `schema-${type.toLowerCase()}`;
    
    const baseUrl = import.meta.env.VITE_SITE_URL || 'https://alaqua.bucketlistgolf.org';
    
    let schemaData: Record<string, any> = {
      '@context': 'https://schema.org',
      '@type': type,
      ...data,
    };

    // Replace relative URLs with absolute URLs
    if (schemaData.url && !schemaData.url.startsWith('http')) {
      schemaData.url = `${baseUrl}${schemaData.url}`;
    }
    if (schemaData.image && !schemaData.image.startsWith('http')) {
      schemaData.image = `${baseUrl}${schemaData.image}`;
    }

    script.textContent = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      const existingScript = document.getElementById(`schema-${type.toLowerCase()}`);
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, [type, data]);

  return null;
};

export const updateMetaTags = (tags: Record<string, string>) => {
  Object.entries(tags).forEach(([name, content]) => {
    let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
    if (!meta) {
      meta = document.querySelector(`meta[property="${name}"]`) as HTMLMetaElement;
    }
    if (meta) {
      meta.content = content;
    } else {
      const newMeta = document.createElement('meta');
      if (name.startsWith('og:') || name.startsWith('twitter:')) {
        newMeta.setAttribute('property', name);
      } else {
        newMeta.setAttribute('name', name);
      }
      newMeta.content = content;
      document.head.appendChild(newMeta);
    }
  });
};
